import React, { useState } from 'react';
import { Form, Button, Image } from 'react-bootstrap';

const mockComments = [
  { name: "User A", text: "sum dolor sit amet, consectetur adi tempor incididunt..." },
  { name: "User B", text: "sum dolor sit amet, consectetur adi..." },
];

const CommentSection = () => {
  const [comments, setComments] = useState(mockComments);
  const [newComment, setNewComment] = useState("");

  const handlePost = () => {
    if (newComment.trim()) {
      setComments([...comments, { name: "You", text: newComment }]);
      setNewComment("");
    }
  };

  return (
    <div className="mt-3">
      <Form.Control
        type="text"
        placeholder="Write a comment..."
        value={newComment}
        onChange={(e) => setNewComment(e.target.value)}
      />
      <Button size="sm" className="mt-2" onClick={handlePost}>Post</Button>

      <div className="mt-3">
        {comments.map((cmt, idx) => (
          <div key={idx} className="d-flex mb-2">
            <Image src="https://i.pravatar.cc/30" roundedCircle className="me-2" />
            <div style={{ fontSize: 14 }}>
              <strong>{cmt.name}:</strong> {cmt.text}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommentSection;
